import { render, staticRenderFns } from "./codepay.vue?vue&type=template&id=0fe982c4&scoped=true&"
import script from "./codepay.vue?vue&type=script&lang=js&"
export * from "./codepay.vue?vue&type=script&lang=js&"
import style0 from "./codepay.vue?vue&type=style&index=0&id=0fe982c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe982c4",
  null
  
)

export default component.exports